export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 10a1.01 1.01 0 01.707.293A1 1 0 0116 11v9h2v2H6v-2h2v-9a1 1 0 011-1h6zm-5 10h4v-8h-4v8z\" fill=\"#7B61FF\"/><path d=\"M20 3a2 2 0 012 2v10a2 2 0 01-2 2h-2v-2h2V5H4v10h2v2H4a2 2 0 01-2-2V5a2 2 0 012-2h16z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};